import { SourceChannelType } from '@/config/constant';

import WYCouponService from './WYCoupon';
import ManualCouponService from './ManualCoupon';

class CouponService {
  private WYService: WYCouponService = new WYCouponService(); // 网鱼券

  private ManualService: ManualCouponService = new ManualCouponService(); // 手工券

  // 初始化券列表
  public initCouponList = (uid: string) => {
    return Promise.all([
      this.WYService.fetchCouponList(uid),
      this.ManualService.fetchCouponList(uid),
    ]).catch(() => null);
  };

  // 批量锁定网鱼券
  public batchLockWYCoupon = this.WYService.batchLockCoupon;

  // 批量解锁网鱼券
  public batchUnlockWYCoupon = this.WYService.batchUnlockCoupon;

  // 重置网鱼券状态
  public resetWYListStatus = this.WYService.resetListStatus;

  // 更新手工券
  public refreshManualList = this.ManualService.refreshCouponList;

  // 是否禁止选券
  public isCouponDisabled = (query: { priceChannel: SourceChannelType; exclude: string[] }) => {
    // 存在有效手工券
    if (this.ManualService.getAVLCount() > 0) return false;
    if (query) {
      if (query.priceChannel === SourceChannelType.WALK_IN) {
        // 线下渠道 没有可用网鱼券
        return this.WYService.getAVLCount(query.exclude) === 0;
      }
    }
    return true;
  };
}

export default CouponService;
